"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    treeAvatarSize: function() {
        return treeAvatarSize;
    },
    treeDataTypes: function() {
        return treeDataTypes;
    },
    treeItemLevelToken: function() {
        return treeItemLevelToken;
    }
});
const _keyboardkeys = require("@fluentui/keyboard-keys");
const treeItemLevelToken = '--fluent-TreeItem--level';
const treeAvatarSize = {
    medium: 32,
    small: 24
};
const treeDataTypes = {
    ArrowLeft: _keyboardkeys.ArrowLeft,
    ArrowRight: _keyboardkeys.ArrowRight,
    Enter: _keyboardkeys.Enter,
    Click: 'Click',
    ExpandIconClick: 'ExpandIconClick',
    End: _keyboardkeys.End,
    Home: _keyboardkeys.Home,
    ArrowUp: _keyboardkeys.ArrowUp,
    ArrowDown: _keyboardkeys.ArrowDown,
    TypeAhead: 'TypeAhead',
    Change: 'Change'
};
